import React from "react";
import { StyledMintModalSlider } from "./MintModalSlider.styled"

export default function MintModalSlider({ max, onChange, value }) {
  const onSliderChange = (event) => {
    onChange(event.target.value);
  }

  return (
    <StyledMintModalSlider>
      <input type="range" min={1} max={max} onChange={onSliderChange} value={value}></input>
    </StyledMintModalSlider>
  )
}
